var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWizard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.055 4.36364C13.4972 4.36364 15.477 2.40997 15.477 0C15.477 2.40997 17.4568 4.36364 19.8991 4.36364C17.4568 4.36364 15.477 6.3173 15.477 8.72727C15.477 6.3173 13.4972 4.36364 11.055 4.36364Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88552 3.83424C4.74897 2.98219 6.14891 2.98219 7.01236 3.83424L22.6465 19.262C23.51 20.1141 23.51 21.4955 22.6465 22.3476C21.7831 23.1996 20.3831 23.1996 19.5197 22.3476L3.88552 6.9198C3.02207 6.06775 3.02207 4.6863 3.88552 3.83424ZM14.8294 14.6337C15.1142 14.3527 15.4573 14.1644 15.8203 14.0687L6.23065 4.60563C5.79892 4.17961 5.09896 4.17961 4.66723 4.60563C4.23551 5.03166 4.23551 5.72238 4.66723 6.14841L14.2569 15.6115C14.3538 15.2533 14.5447 14.9147 14.8294 14.6337ZM20.3014 21.5762C20.7331 22.0022 21.4331 22.0022 21.8648 21.5762C22.2965 21.1502 22.2965 20.4594 21.8648 20.0334C21.4331 19.6074 20.7331 19.6074 20.3014 20.0334C19.8697 20.4594 19.8697 21.1502 20.3014 21.5762Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21101 8.72727C2.21101 9.93226 1.2211 10.9091 0 10.9091C1.2211 10.9091 2.21101 11.8859 2.21101 13.0909C2.21101 11.8859 3.20091 10.9091 4.42201 10.9091C3.20091 10.9091 2.21101 9.93226 2.21101 8.72727Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31651 19.6364C5.75872 19.6364 7.73852 17.6827 7.73852 15.2727C7.73852 17.6827 9.71832 19.6364 12.1605 19.6364C9.71832 19.6364 7.73852 21.59 7.73852 24C7.73852 21.59 5.75872 19.6364 3.31651 19.6364Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizard);
export default __webpack_public_path__ + "static/media/Wizard.9222ff8f34a8dbf1cf182996b2dd8550.svg";
export { ForwardRef as ReactComponent };